export type PrometheusHaProxyBackendTotalBytesOutStatsBackendApiProps = {
    created: number;
    haproxy_server_bytes_out_total: number;
};

export default class PrometheusHaProxyBackendTotalBytesOutStats {
    readonly created: number;
    readonly haproxyServerBytesOutTotal: number;

    constructor(
        props: PrometheusHaProxyBackendTotalBytesOutStatsBackendApiProps
    ) {
        this.created = props.created;
        this.haproxyServerBytesOutTotal = props.haproxy_server_bytes_out_total;
    }
}
